import { useContext } from "react";
import {
  ApplicationContext,
  ApplicationContextValue,
} from "../context/ApplicationContext";

const useApplicationContext = () => {
  return useContext<ApplicationContextValue>(ApplicationContext);
};

export default useApplicationContext;
